import { Button, ButtonProps } from '@mui/material'
import { useTheme } from '@mui/material'
import { SxProps } from '@mui/system'

interface InvertPrimaryButtonProps extends ButtonProps {
    px?: number | string
    py?: number | string
    title?: string
}

function InvertPrimaryButton(props: InvertPrimaryButtonProps) {
    const { title, px, py, ...buttonProps } = props

    const theme = useTheme()

    const style: SxProps = {
        backgroundColor: 'outlinePrimary.main',
        color: 'outlinePrimary.contrastText',
        '&:hover': {
            backgroundColor: 'outlinePrimary.dark',
            color: 'white',
            // Prevent button's unexpected color changing
            '@media (hover: none)': {
                backgroundColor: 'outlinePrimary.main',
                color: 'outlinePrimary.contrastText',
                boxShadow: 'none',
            },
        },
        boxShadow: 'none',
        border: `1px solid ` + theme.palette.outlinePrimary.dark,
        '&:disabled': {
            backgroundColor: 'outlinePrimary.main',
            color: 'disabled.dark',
            border: `1px solid ` + theme.palette.disabled.dark,
            fontWeight: 600,
        },
    }

    return (
        <Button
            {...buttonProps}
            children={title ? <> {title}</> : buttonProps.children}
            sx={{
                ...buttonProps.sx,
                ...style,
                py: py,
                px: px,
            }}
        />
    )
}

export default InvertPrimaryButton
